import React, { useEffect, useRef, useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import { Avatar, IconButton } from "@mui/material";
import { useChatState } from "../../context/context";
import { io } from "socket.io-client";
import { groupBy, isAuthor, todaysDate } from "../../utils";
import moment from "moment";
import { toast } from "react-toastify";
import MessageSkeleton from "../../components/Skeleton/MessageSkeleton";
import ChatHeader from "./Section/ChatHeader";
import InputEmoji from "react-input-emoji";
import Admin from "../../css/Avatar1.png";

var socket = io(process.env.REACT_APP_API_URL);
var selectedChatCompare;

const SingleChat = ({ fetchAgain, setFetchAgain }) => {
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const adminId = localStorage.getItem("communityId");
  const chatRef = useRef(null);
  const { user, selectedChat, notification, setNotification } = useChatState();

  // fetching all messages according to room id
  const fetchChats = () => {
    if (!selectedChat.roomId) return;
    setLoading(true);
    // socket.emit("setup", selectedChat.receiverId);
    socket.on("receiveMessages", (data) => {
      setLoading(false);
      setMessages(data.result);
    });
  };
  // send messages handler
  const messageSendHandler = () => {
    if (!message.trim()) toast.error("Please type a message");
    else {
      socket.emit("sendMessage", {
        message: message,
        sender: adminId,
        receiver: selectedChat?.receiverId,
        messageType: "text",
        roomId: selectedChat?.roomId,
        senderType: "admin",
      });
      setFetchAgain(!fetchAgain);
      setMessages([
        ...messages,

        {
          _id: `${message}`,
          createdAt: new Date(),
          message: message,
          roomId: selectedChat.roomId,
          senderType: "admin",
          // receiverId: selectedChat.receiverId,
          // senderId: selectedChat.receiverId,
        },
        ,
      ]);

      setMessage("");
      if (chatRef.current) {
        chatRef.current.scrollTop = chatRef.current.scrollHeight;
      }
    }
  };

  useEffect(() => {
    socket.emit("chatMessage", {
      roomId: selectedChat.roomId,
      loginId: adminId,
      type: "admin",
    });

    //eslint-disable-next-line
  }, [selectedChat]);

  useEffect(() => {
    socket.emit("chatMessage", {
      roomId: selectedChat.roomId,
      loginId: adminId,
      type: "admin",
    });
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    fetchChats();
    selectedChatCompare = selectedChat;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChat]);
  // auto scroll down
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    socket.on("receiveMessages", (data) => {
      console.log(data, "receiveMessages");
      if (data.status == 200) {
        if (
          !selectedChatCompare ||
          selectedChatCompare.receiverId === data.loginId
        ) {
          if (!notification.includes(data)) {
            setNotification([data, ...notification]);
            setFetchAgain(!fetchAgain);
          }
        } else {
          console.log("admin");
          // setMessages([...messages, data.result]);
          setMessages(data.result);
          setFetchAgain(!fetchAgain);
        }
      } else {
        console.error("errr");
      }
    });
  }, [selectedChat.roomId]);
  return (
    <>
      {/* checks User is selected */}
      {selectedChat?.receiverId ? (
        <div className="col-md-6 col-lg-7 col-xl-8">
          {/* Chat Header */}
          <ChatHeader selectedChat={selectedChat} />
          {/* All Messages */}
          {loading ? (
            <MessageSkeleton />
          ) : (
            <>
              <div
                className="pt-3 pe-3"
                data-mdb-perfect-scrollbar="true"
                style={{
                  position: "relative",
                  height: "400px",
                  overflow: "scroll",
                }}
                ref={chatRef}
              >
                {messages &&
                  messages.length > 0 &&
                  messages?.map((messageObj) => {
                    // Check if the object is defined and has the necessary properties
                    if (
                      messageObj &&
                      messageObj._id &&
                      messageObj.message &&
                      messageObj.createdAt
                    ) {
                      const {
                        _id,
                        message,
                        createdAt,
                        senderId,
                        senderType,
                      } = messageObj;
                      console.log(messageObj, "messageObj");
                      return (
                        <div
                          className={`d-flex flex-row ${
                            senderType === "admin"
                              ? "justify-content-end"
                              : "justify-content-start"
                          }`}
                          key={_id}
                        >
                          {senderType === "user" && (
                            <Avatar
                              alt={selectedChat.roomId}
                              src={selectedChat.receiverImage}
                            />
                          )}
                          {senderType === "admin" && (
                            <Avatar alt="Admin" src={Admin} />
                          )}

                          <div>
                            <p
                              className="small p-2 ms-3 mb-1 rounded-3"
                              style={{ backgroundColor: "#f5f6f7" }}
                            >
                              {message}
                            </p>
                            <p className="small ms-3 mb-3 rounded-3 text-muted float-end">
                              {moment(createdAt).format("HH:mm")}
                            </p>
                          </div>
                        </div>
                      );
                    } else {
                      // If the object is undefined or doesn't have the necessary properties, return null
                      return null;
                    }
                  })}
              </div>
              {/* Send messages form */}
              <div className="text-muted d-flex justify-content-start align-items-center pe-3 pt-3 mt-2">
                {/* {userProfile.profile === "" ? (
                  <Avatar src="/broken-image.jpg" />
                ) : ( */}
                <img
                  src={Admin}
                  alt="avatar 3"
                  style={{ width: "40px", height: "100%" }}
                  className="rounded-circle"
                />
                {/* )} */}

                <div className="mx-1 w-100">
                  <InputEmoji
                    value={message}
                    onChange={setMessage}
                    cleanOnEnter
                    onEnter={messageSendHandler}
                    placeholder="Type a message"
                  />
                </div>
                {message.length > 0 && (
                  <IconButton aria-label="send" onClick={messageSendHandler}>
                    <SendIcon color="primary" />
                  </IconButton>
                )}
              </div>
            </>
          )}
        </div>
      ) : (
        <div
          className="col-md-6 col-lg-7 col-xl-8"
          style={{ background: "#e5f5fd", borderRadius: "5px" }}
        >
          <div className="d-flex h-100 justify-content-center align-items-center">
            {/* <img src={} alt="Mednovate" /> */}
          </div>
        </div>
      )}
    </>
  );
};

export default SingleChat;
